import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { store } from './store';
import { theme } from './config/theme';
import { ThemeProvider } from './contexts/ThemeContext'; // Import ThemeProvider
import App from './App';
import './index.css';

// Import Mantine styles
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/spotlight/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <MantineProvider theme={theme} defaultColorScheme="light">
            <ModalsProvider>
              <ThemeProvider> {/* ThemeProvider is INSIDE MantineProvider but BEFORE App */}
                <Notifications position="top-right" zIndex={1000} />
                <App />
              </ThemeProvider>
            </ModalsProvider>
          </MantineProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);